import React from "react";

export const ProductContext = React.createContext({});

export const ProductProvider = ProductContext.Provider;
